import "./BurgerMenu.scss";

interface BurgerMenuProps {
  isOpen: boolean;
  onToggle(): void;
  onClearProducts(): void;
  onLogout(): void;
}

export default function BurgerMenu({
    isOpen,
    onToggle,
    onClearProducts,
    onLogout,
  }: BurgerMenuProps) {
    return (
      <div className="burger-wrapper">
        <button
          className={`burger-btn${isOpen ? " open" : ""}`}
          onClick={onToggle}
          aria-label="Меню"
        >
          ☰
        </button>
  
        <div className={`menu${isOpen ? " open" : ""}`}>
          <button className="menu-btn" onClick={onClearProducts}>
            Новый клиент
          </button>
          <button className="menu-btn" onClick={onLogout}>
            Выход
          </button>
        </div>
      </div>
    );
  }
  
